const FALLBACK = "download";
const RESERVED_CHARS = /[\\/:*?"<>|]/g;
// ASCII whitespace controls (\t \n \r \v \f) round-trip to a space so
// surrounding tokens stay separated. Everything else in Cc/Cf is dropped.
const ASCII_WHITESPACE_CONTROLS = /[\t\n\r\v\f]/g;
const COLLAPSE_WS = /\s+/g;
const LEADING_TRAILING = /^[.\s]+|[.\s]+$/g;
// Cc = control, Cf = format (zero-width joiner/non-joiner, BOM, RTL marks, etc.).
// Both classes are invisible to users but break HTTP Content-Disposition encoding
// on the way back down through Azure's `rscd` SAS query parameter.
const INVISIBLE = /[\p{Cc}\p{Cf}]/gu;

export function sanitizeFileName(name: string | null | undefined): string {
  if (!name || !name.trim()) return FALLBACK;
  let s = name.normalize("NFKC");
  s = s.replace(ASCII_WHITESPACE_CONTROLS, " ");
  s = s.replace(INVISIBLE, "");
  s = s.replace(RESERVED_CHARS, "_");
  s = s.replace(COLLAPSE_WS, " ").trim();
  s = s.replace(LEADING_TRAILING, "");
  return s || FALLBACK;
}

export function fileNameRequiresSanitization(name: string | null | undefined): boolean {
  return sanitizeFileName(name) !== (name ?? "");
}

/**
 * Returns a clone of the given File with a sanitized name. File.name is
 * read-only, so callers must use the returned File going forward.
 */
export function withSanitizedName(file: File): File {
  const clean = sanitizeFileName(file.name);
  if (clean === file.name) return file;
  return new File([file], clean, { type: file.type, lastModified: file.lastModified });
}
